import React from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Stack, Text } from "@bookingcom/bui-react";
import { BaggageItemMobile } from "./BaggageItem.mobile.js";
export function BaggageSegmentMobile(props) {
    const { flightSegment, baggageSegment, showHeader, hideIncludedSection } = props;
    return (React.createElement(Stack, { gap: 2 },
        showHeader ? React.createElement(BaggageSegmentHeaderMobile, { flightSegment: flightSegment }) : undefined,
        React.createElement(BaggageSegmentListMobile, { hideIncludedSection: hideIncludedSection, baggageSegment: baggageSegment })));
}
function BaggageSegmentHeaderMobile(props) {
    const { flightSegment } = props;
    const i18n = useI18n();
    const { arrivalAirport } = flightSegment;
    return (React.createElement(Text, { tagName: "h4", variant: "emphasized_2" }, i18n.trans(t("flights_details_route", {
        variables: {
            city_name: arrivalAirport.cityName || arrivalAirport.name
        }
    }))));
}
function BaggageSegmentListMobile(props) {
    const { baggageSegment, hideIncludedSection } = props;
    return baggageSegment.map((item, i) => {
        return (React.createElement(BaggageItemMobile, { luggage: item, key: `${item.luggageType}-${i}`, hideIncludedSection: hideIncludedSection }));
    });
}
